import React, { useEffect, useState } from "react";
import "../../../src/common.css";
import "./sidebar-modern.css";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../../hooks/services/services";

const LeftSideBar = ({ open, drawerClick, onHover }) => {
  const userRole = localStorage.getItem("userRole")?.trim();
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const res = await logoutUser();
      if (res) {
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  useEffect(() => {
    if (open || isHovered) {
      document.body.classList.add("body-hover");
    } else {
      document.body.classList.remove("body-hover");
    }
  }, [open, isHovered]);

  useEffect(() => {
    if (open) {
      setIsHovered(false);
      if (onHover) onHover(false);
    }
  }, [open, onHover]);
  const sidebarRef = React.useRef(null);

  const scrollDown = () => {
    if (sidebarRef.current) {
      sidebarRef.current.scrollBy({ top: 100, behavior: 'smooth' });
    }
  };


  return (
    <div
      className={`left-bar ${!open ? "hideSideBar" : ""} ${open || isHovered ? "result_hover" : ""}`}
      {...(!open && {
        onMouseEnter: () => { setIsHovered(true); if (onHover) onHover(true); },
        onMouseLeave: () => { setIsHovered(false); if (onHover) onHover(false); },
      })}
    >

      <div
        className={`sidebar-toggle-btn ${open || isHovered ? "open" : "collapsed"}`}
        title="Toggle Sidebar"
        onClick={drawerClick}
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5e4e86"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </div>

      <ul className="" ref={sidebarRef} style={{ height: 'calc(100% - 60px)', overflowY: 'auto' }}>

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/thematic-dashboard" ? "active" : ""
              }`}
            title="Thematic Dashboard"
            onClick={() => navigate("/thematic-dashboard")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add program analytics.svg" alt="Thematic Dashboard" />{" "}
              <span>Thematic Dashboard</span>
            </a>
          </li>
        )}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/dashboard" ? "active" : ""
              }`}
            title="Dashboard"
          >
            <NavLink
              to="/dashboard"
            >
              <img src="../images/dashboard.svg" alt="Dashboard" /> <span>Dashboard</span>
            </NavLink>
          </li>
        )}


        {userRole === "Admin" && (
          <li
            className={`nav-singl ${location.pathname === "/adduser" ? "active" : ""
              }`}
            title="Add User"
            onClick={() => navigate("/adduser")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add_user.svg" alt="Add User" /> <span>Add User</span>
            </a>
          </li>
        )}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/user-list" ? "active" : ""
              }`}
            title="Add Beneficiary Data"
            onClick={() => navigate("/user-list")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add data.svg" alt="Users" />{" "}
              <span>Users </span>
            </a>
          </li>
        )}

        {userRole === "Super Admin" && (
          <li
            className={`nav-singl ${location.pathname === "/addproject" ? "active" : ""
              }`}
            title="Add Project"
            onClick={() => navigate("/addproject")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add_project.svg" alt="Add Project" /> <span>Add Project</span>
            </a>
          </li>
        )}
        <li
          className={`nav-singl ${location.pathname === "/rfq-data" ? "active" : ""
            }`}
          title="RFQ Data"
          onClick={() => navigate("/rfq-data")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/add rfq data.svg" alt="Add RFQ Data" /> <span>Add RFQ Data</span>
          </a>
        </li>
        <li
          className={`nav-singl ${location.pathname === "/add-rfp-data" ? "active" : ""
            }`}
          title="Add RFP Data"
          onClick={() => navigate("/add-rfp-data")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/add rfp data.svg" alt="Add RFP Data" /> <span>Add RFP Data</span>
          </a>
        </li>




        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-survey" ? "active" : ""
              }`}
            title="Add Survey"
            onClick={() => navigate("/add-survey")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add survey.svg" alt="Add Survey" /> <span>Add Survey </span>
            </a>
          </li>
        )}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-survey-fields" ? "active" : ""
              }`}
            title="Add Survey Field"
            onClick={() => navigate("/add-survey-fields")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add survey fields.svg" alt="Add Survey Field" />{" "}
              <span>Add Survey Field</span>
            </a>
          </li>
        )}
        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-modal-Type" ? "active" : ""
              }`}
            title="Add Modal Header"
            onClick={() => navigate("/add-modal-Type")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add modal header.svg" alt="Add Modal Type" />{" "}
              <span>Add Modal Type</span>
            </a>
          </li>
        )}
        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-modal-header" ? "active" : ""
              }`}
            title="Add Modal Header"
            onClick={() => navigate("/add-modal-header")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add modal header.svg" alt="Add Modal Header" />{" "}
              <span>Add Modal Header</span>
            </a>
          </li>
        )}

        <li
          className={`nav-singl ${location.pathname === "/add-survey-data" ? "active" : ""
            }`}
          title="Add Survey Data"
          onClick={() => navigate("/add-survey-data")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/survey form.svg" alt="Add Survey Data" /> <span>Add Survey Data</span>
          </a>
        </li>
        <li
          className={`nav-singl ${location.pathname === "/view-survey-data" ? "active" : ""
            }`}
          title="View Survey Data"
          onClick={() => navigate("/view-survey-data")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/view data.svg" alt="View Survey Data" /> <span>View Survey Data</span>
          </a>
        </li>
        {/* <li
          className={`nav-singl ${location.pathname === "/bulk-data" ? "active" : ""
            }`}
          title="Bulk Data Settings"
          onClick={() => navigate("/bulk-data")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/add data.svg" alt="Bulk Data Settings" /> <span>Bulk Data Settings</span>
          </a>
        </li> */}

        <li
          className={`nav-singl ${location.pathname === "/add-action-plan-management" ? "active" : ""
            }`}
          title="Add APM"
          onClick={() => navigate("/add-action-plan-management")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/action plan management.svg" alt="Add Action Plan" />{" "}
            <span>Add Action Plan</span>
          </a>
        </li>
        {(userRole === "Super Admin" || userRole === "Admin") && (
        <li
          className={`nav-singl ${location.pathname === "/activity-analysis" ? "active" : ""
            }`}
          title="Activity Analysis"
          onClick={() => navigate("/activity-analysis")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/view data.svg" alt="Activity Analysis" />{" "}
            <span>Activity Analysis</span>
          </a>
        </li>
        )}
        <li
          className={`nav-singl ${location.pathname === "/project-tracker" ||
            location.pathname === "/project-tracker/project-details" ||
            location.pathname === "/project-tracker/create-milestone"
            ? "active"
            : ""
            }`}
          title="Project Tracker"
          onClick={() => navigate("/project-tracker")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/project tracker.svg" alt="Project Tracker" />{" "}
            <span>Project Tracker</span>
          </a>
        </li>

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <>
            <li
              className={`nav-singl ${location.pathname === "/addprogram" ? "active" : ""
                }`}
              title="Add Program"
              onClick={() => navigate("/addprogram")}
            >
              <a href="#" onClick={(e) => e.preventDefault()}>
                <img src="../images/add_program.svg" alt="Add Program" /> <span>Add Program</span>
              </a>
            </li>
            <li
              className={`nav-singl ${location.pathname === "/add-fields" ? "active" : ""
                }`}
              title="Add Program Field"
              onClick={() => navigate("/add-fields")}
            >
              <a href="#" onClick={(e) => e.preventDefault()}>
                <img src="../images/program field.svg" alt="Add Program Field" />{" "}
                <span>Add Program Field</span>
              </a>
            </li>
          </>
        )}

        {(userRole === "Admin" || userRole === "User") && (
          // <li
          //   className={`nav-singl ${
          //     location.pathname === "/add-beneficiary-data" ? "active" : ""
          //   }`}
          //   title="Add Beneficiary Data"
          //   onClick={() => navigate("/add-beneficiary-data")}
          // >
          //   <a>
          //     <img src="../images/add data.svg" />{" "}
          //     <span>Add Beneficiary Data</span>
          //   </a>
          // </li>

          <li
            className={`nav-singl ${location.pathname === "/add-beneficiary-data" ? "active" : ""
              }`}
            title="Add Beneficiary Data"
            onClick={() => navigate("/add-beneficiary-data")}
          >
            <NavLink
              to="/add-beneficiary-data"
            >
              <img src="../images/dashboard.svg" alt="Add Beneficiary Data" /> <span>Add Beneficiary Data</span>
            </NavLink>

          </li>
        )}

        {/* {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className="nav-singl"
            title="Events"
            onClick={() => navigate("/events")}
          >
            <a href="#">
              <img src="../images/add_program_data.svg" /> <span>Events</span>
            </a>
          </li>
        )} */}

        {(userRole === "Super Admin" || userRole === "Admin" || userRole === "User") && (
          <li
            className={`nav-singl ${location.pathname === "/view-entry-data" ? "active" : ""
              }`}
            title="View Entry Data"
            onClick={() => navigate("/view-entry-data")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/view data.svg" alt="View Data" /> <span>View Data</span>
            </a>
          </li>
        )}
        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-sub-program" ? "active" : ""
              }`}
            title="Add SubProgram"
            onClick={() => navigate("/add-sub-program")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add subprogram.svg" alt="Add SubProgram" />{" "}
              <span>Add SubProgram</span>
            </a>
          </li>
        )}
        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-subprogram-fields" ? "active" : ""
              }`}
            title="Add Sub-Program Field"
            onClick={() => navigate("/add-subprogram-fields")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/sub Program Field.svg" alt="Add Sub-Program Field" />{" "}
              <span>Add Sub-Program Field</span>
            </a>
          </li>
        )}
        {/* {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-analytics" ? "active" : ""
              }`}
            title="Add Analytics"
            onClick={() => navigate("/add-analytics")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add program analytics.svg" alt="Add Program Analytics" />{" "}
              <span>Add Program Analytics</span>
            </a>
          </li>
        )}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/add-survey-analytics" ? "active" : ""
              }`}
            title="Add Analytics"
            onClick={() => navigate("/add-survey-analytics")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add program analytics.svg" alt="Add Survey Analytics" />{" "}
              <span>Add Survey Analytics</span>
            </a>
          </li>
        )} */}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/dynamic-analytics" ? "active" : ""
              }`}
            title="Dynamic Analytics"
            onClick={() => navigate("/dynamic-analytics")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add program analytics.svg" alt="Dynamic Analytics" />{" "}
              <span>Dynamic Analytics</span>
            </a>
          </li>
        )}

        {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${location.pathname === "/dynamic-charts" ? "active" : ""
              }`}
            title="Dynamic Charts"
            onClick={() => navigate("/dynamic-charts")}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              <img src="../images/add program analytics.svg" alt="Dynamic Charts" />{" "}
              <span>Dynamic Charts</span>
            </a>
          </li>
        )}

        

        <li
          className={`nav-singl ${location.pathname === "/add-modal-header" ? "active" : ""
            }`}
          title="Add Modal Header"
          onClick={() => navigate("/reset-password")}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/add modal header.svg" alt="Reset Password" />{" "}
            <span>Reset Password</span>
          </a>
        </li>



        {/* {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className="nav-singl"
            title="Add RFP Field"
            onClick={() => navigate("/add-rfp-fields")}
          >
            <a href="#">
              <img src="../images/add_program_field.svg" />{" "}
              <span>Add RFP Field</span>
            </a>
          </li>
        )} */}

        {/* {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className="nav-singl"
            title="View RFP Data"
            onClick={() => navigate("/view-rfp-data")}
          >
            <a href="#">
              <img src="../images/add_program_field.svg" />{" "}
              <span>View RFP Data</span>
            </a>
          </li>
        )} */}
        {/* {(userRole === "Super Admin" || userRole === "Admin") && (
          <li
            className={`nav-singl ${
              location.pathname === "/survey-form" ? "active" : ""
            }`}
            title="Survey Form"
            onClick={() => navigate("/survey-form")}
          >
            <a href="#">
              <img src="../images/add_program_field.svg" />{" "}
              <span>Survey Form</span>
            </a>
          </li>
        )} */}
        <li
          className="nav-singl"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          <a href="#" onClick={(e) => e.preventDefault()}>
            <img src="../images/logout-circle-r-line.svg" alt="Logout" /> <span> Log Out</span>
          </a>
        </li>
      </ul>



      <div
        className="sidebar-scroll-btn"
        onClick={scrollDown}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </div>

    </div>
  );
};

export default LeftSideBar;